/* DC | Sacola lateral: adicionar Leve junto / Oferta, carrossel e animacao do frete */
(function () {
  if (window.__dcSacola) return;
  window.__dcSacola = true;

  function sectionIds() {
    var ids = [];
    document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
      if (ids.indexOf(el.dataset.sectionId) === -1) ids.push(el.dataset.sectionId);
    });
    return ids;
  }

  function rootUrl() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  }

  /* ---------- Frete gratis: comemoracao ---------- */
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var COLORS = ['var(--dc-accent)', 'var(--dc-green)', '#F2C14E', '#F59AB8', '#7CC46F'];

  function celebrate(el) {
    el.classList.remove('is-celebrate');
    void el.offsetWidth;
    el.classList.add('is-celebrate');
    setTimeout(function () { el.classList.remove('is-celebrate'); }, 1800);
    if (reduce) return;
    var origin = el.querySelector('.dc-frete__track');
    for (var i = 0; i < 22; i++) {
      var c = document.createElement('span');
      c.className = 'dc-confetti';
      var ang = (Math.random() * 160 + 190) * Math.PI / 180;
      var dist = 40 + Math.random() * 70;
      c.style.setProperty('--x', Math.round(Math.cos(ang) * dist) + 'px');
      c.style.setProperty('--y', Math.round(Math.sin(ang) * dist) + 'px');
      c.style.setProperty('--r', Math.round(Math.random() * 540 - 270) + 'deg');
      c.style.left = (55 + Math.random() * 45) + '%';
      c.style.background = COLORS[i % COLORS.length];
      c.style.animationDelay = Math.round(Math.random() * 120) + 'ms';
      if (i % 3 === 0) c.style.borderRadius = '50%';
      (origin || el).appendChild(c);
      (function (node) { setTimeout(function () { node.remove(); }, 1500); })(c);
    }
  }

  function checkFrete() {
    var el = document.querySelector('.dc-sacola [data-dc-frete]');
    if (!el) return;
    var ok = el.getAttribute('data-ok') === 'true';
    var prev = null;
    try { prev = sessionStorage.getItem('dcFreteOk'); } catch (e) {}
    if (ok && prev === 'false') celebrate(el);
    try { sessionStorage.setItem('dcFreteOk', ok ? 'true' : 'false'); } catch (e) {}
  }

  var queued = false;
  function queueCheck() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; checkFrete(); });
  }

  function startObserver() {
    checkFrete();
    new MutationObserver(queueCheck).observe(document.body, { subtree: true, childList: true, attributes: true, attributeFilter: ['data-ok'] });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', startObserver);
  else startObserver();

  /* ---------- Cliques ---------- */
  document.addEventListener('click', function (e) {
    var nav = e.target.closest('[data-dc-nav]');
    if (nav) {
      e.preventDefault();
      var box = nav.closest('[data-dc-carousel]');
      var track = box && box.querySelector('[data-dc-track]');
      if (!track) return;
      var card = track.querySelector('[data-dc-slide]');
      var step = card ? card.getBoundingClientRect().width + 8 : track.clientWidth * 0.8;
      track.scrollBy({ left: nav.getAttribute('data-dc-nav') === 'next' ? step : -step, behavior: 'smooth' });
      return;
    }

    var btn = e.target.closest('[data-dc-add]');
    if (!btn) return;
    e.preventDefault();
    if (btn.disabled || btn.classList.contains('is-loading')) return;

    var variantId = Number(btn.getAttribute('data-variant-id'));
    if (!variantId) return;

    var item = { id: variantId, quantity: 1 };
    var offer = btn.getAttribute('data-dc-offer');
    if (offer) item.properties = { _dc_oferta: offer };

    var ids = sectionIds();
    btn.classList.add('is-loading');

    fetch(rootUrl() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ items: [item], sections: ids.join(','), sections_url: window.location.pathname })
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || data.status) throw new Error(data.description || data.message || 'Erro ao adicionar');
          return data;
        });
      })
      .then(function (data) {
        var count;
        var html = ids[0] && data.sections && data.sections[ids[0]];
        if (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var c = doc.querySelector('[ref="cartItemCount"]');
          if (c) count = parseInt(c.textContent, 10);
        }
        var ev = new Event('cart:update', { bubbles: true });
        ev.detail = {
          resource: { item_count: count, items: data.items },
          sourceId: 'dc-sacola',
          data: { source: 'dc-sacola', itemCount: count, variantId: String(variantId), sections: data.sections || {} }
        };
        document.dispatchEvent(ev);
      })
      .catch(function (err) {
        console.error('[DC Sacola]', err);
        btn.classList.add('is-error');
        btn.setAttribute('title', err.message);
        setTimeout(function () { btn.classList.remove('is-error'); }, 2500);
      })
      .finally(function () {
        btn.classList.remove('is-loading');
      });
  });
})();
